export default __webpack_public_path__ + "static/arif-e1d8de67c5a0844d19dea74cc2ae249a.png";